import { t } from 'i18next';
import { useCallback } from 'react';
import { SettingToggleRow } from '../../../../components/setting-toggle-row';
import { DOCS_URLS } from '../../constants';
import { useStorefrontOptionsControls } from '../../context/storefront-options-context';
import type { SparkOptions } from '../../types/spark-options';
import { OptionsCard } from '../options-card';
import { TranslationsEditor } from '../translations-editor';

const CARD =
  'features:storefront_options.pages.storefront_options_page.cards.translation_overrides';

export function TranslationOverridesCard() {
  const { options, set } = useStorefrontOptionsControls();

  const handleChange = useCallback(
    (value: SparkOptions['translations']) => set('translations', value),
    [set],
  );

  return (
    <OptionsCard
      title={t(`${CARD}.title`)}
      subtitle={t(`${CARD}.subtitle`)}
      learnMoreUrl={DOCS_URLS.translationOverrides}
    >
      <SettingToggleRow
        label={t(`${CARD}.fields.show_translations.label`)}
        description={t(`${CARD}.fields.show_translations.description`)}
        checked={options.showTranslations}
        onChange={(checked) => set('showTranslations', checked)}
        learnMoreUrl={DOCS_URLS.showTranslations}
      />
      <TranslationsEditor value={options.translations} onChange={handleChange} />
    </OptionsCard>
  );
}
